import { create } from 'zustand';
import { WaSummaryModel } from './models/workplace/WaSummary';

export interface SummaryStore {
  summary: WaSummaryModel | null;
  setSummary: (summary: WaSummaryModel | null) => void;
}

export const useWaSummaryStore = create<SummaryStore>()((set) => ({
  summary: null,
  setSummary: (summary) => set({ summary }),
}));
